import { getSystemSettings, setDestination, getDestination, setSystemSettings } from "./SettingsRetriever";

const saveDestination = (destinationID) => {
    let settings = getSystemSettings();
    let { multiDestination } = settings;
    let destination = multiDestination.list.find(dest => parseInt(dest.id) === parseInt(destinationID));
    let destinations = getDestination();

    destination.config.categories.forEach(category => {
        settings.categories.forEach(cat => {
            if (cat.code === category.code){
                cat.config = { ...cat.config, ...category.config }
            }
        })
    })

    setSystemSettings(settings)

    if (destinations){
        if (destinations.indexOf(destinationID) >= 0){
            destinations.splice(destinations.indexOf(destinationID, 1))
        } else {
            destinations.push(destinationID)
        }
        setDestination(destinations)
    } else {
        setDestination([destinationID])
    }

    const event = new CustomEvent("destinationUpdate");
    document.dispatchEvent(event);
}

export default saveDestination;